module.exports = __webpack_public_path__ + "media/Components/fonts/boldKameron-faa0f2b611d139b4b451cd38dce701ab.ttf";